import { useContext, useEffect } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { CustomerForm } from '../components/form/CustomerForm';

export const CreateCustomerPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Nuevo Cliente ');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Clientes',
                route: Private_Routes.CUSTOMER_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_CUSTOMER,
            },
        ]);
    }, [lang]);

    return <CustomerForm isNewCustomer={true} />;
};
